import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import RateCardComponent from '../components/rate-card.component';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import Popup from '../../../../../../common/components/popup';
import { deepCopy } from '../../../../../../common/services/common.service';
import ModalRateCardRuleComponent from '../components/modal-rate-card-rule.component';
import { useSelector } from 'react-redux';
import { selectPinCodesListItems } from '../../../../../../redux/pin-codes/selector';
import { pinCodes } from '../../../../../../redux/pin-codes/action';
import { selectCategoriesListItems } from '../../../../../../redux/categories/selector';
import { categories } from '../../../../../../redux/categories/action';
import { measureDimensions } from '../../../../../../redux/measure-dimensions/action';
import { selectMeasureDimensionsListItems } from '../../../../../../redux/measure-dimensions/selector';
import { selectVariantsListItems } from '../../../../../../redux/variants/selector';
import { variants } from '../../../../../../redux/variants/action';
import { selectProductTypesListItems } from '../../../../../../redux/product-types/selector';
import { productTypes } from '../../../../../../redux/product-types/action';
import { products } from '../../../../../../redux/products/action';
import { selectProductsListItems } from '../../../../../../redux/products/selector';
import * as R from 'ramda'
import { customers } from '../../../../../../redux/customers/action';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { selectAccountTypesListItems } from '../../../../../../redux/account-types/selector';
import { accountTypes } from '../../../../../../redux/account-types/action';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { ListCriteria } from '../../../../types/list-criteria';
import { rateCards } from '../../../../../../redux/rate-cards/action';
import PageLoader from '../../../../../../components/PageLoader';
import { selectRateCardQueryItems } from '../../../../../../redux/rate-cards/selector';

let currentChange: any = {}

type TaxonomyDetails = {
    ProductId: any,
    ProductName: string,
    DistanceUnitId: string,
    ProductTypeName: string,
    VariantName: string,
    Charge: number,
    IsIncludeProductBasePrice: boolean,
    DistanceIncrement: Number,
    DistanceIncrementCharge: Number,
    MinimunDistance: Number,
    MaximumDistance: Number,
};

type RateCard = {
    Id: number;
    Name: string;
    EdgeDBNDomainCode: string,
    RateCardType: string,
    IsActive: boolean,
    StartDateUtc: string,
    EndDateUtc: string,
    MinimunDistance: number,
    MaximumDistance: number,
    IsInlcudeStoreAsOriginLocation: boolean,
    DistanceUnitId: number,
    DistanceIncrement: number,
    DistanceIncrementCharge: number,
    PinCode: [],
    TaxonomyDetails: TaxonomyDetails[];
};

const ManagementRateCardAdvance = () => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()

    //Declare useSelector here
    const pinCodesLists = useSelector(selectPinCodesListItems)
    const categoryLists = useSelector(selectCategoriesListItems)
    const measureDimensionsLists = useSelector(selectMeasureDimensionsListItems)
    const variantsLists = useSelector(selectVariantsListItems)
    const productsLists = useSelector(selectProductsListItems)
    const productTypesLists = useSelector(selectProductTypesListItems)
    const customerLists = useSelector(selectCustomersListItems)
    const accountItems = useSelector(selectAccountsListItems)
    const libraryData = useSelector(selectListItems)
    const TypeData = libraryData?.result?.Type
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const queryItems = useSelector(selectRateCardQueryItems)

    //Declare useState here
    const [rateCardRules, setRateCardRules] = useState<RateCard[]>([]);
    const [rateCardFullRulesData, setRateCardFullRulesData] = useState<any>([]);
    const [taxonomy, setTaxonomy] = useState<TaxonomyDetails[]>([]);
    const [columnDefs, setColumnDefs] = useState({});
    const [addItem, setAddItem] = useState<any>(undefined);
    const [mediaFiles, setMediaFiles] = useState<any>([])
    const [selectedRateCards, setSelectedRateCards] = useState<any>([])
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerId, setOwnerId] = useState<number | undefined>();
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [accountsList, setAccountsList] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)

    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value)
    }
    const handleInnerFormChange: any = ({ value, field, data }: any) => {
        currentChange = { value, field, data, idx: 0 }
        const fields = R.split(
            '.',
            field
        );
        const valueData = { ...data, [fields[1]]: value }// inner data update
        setSelectedRateCards({ ...selectedRateCards, [fields[0]]: valueData });
    }
    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedRateCards({ ...selectedRateCards, [field]: event })

    }


    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    //Fetch Query 
    const fetchQueryById = () => {
        dispatch(rateCards.query({
            url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/mobility/rate-cards/fetch-detail`, entity: 'rateCards', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }


    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }


    //Back function
    const back = () => {
        navigate('/management/policy-manager/rate-cards')
    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setRateCardFullRulesData((prevState: any) =>
            prevState.filter((item: any) => item?.Name !== data?.Name)
        );

    };

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add RateCard Rules</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name' },


        ]);
    }

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setRateCardRules([])
        setTaxonomy([])
    }

    //OnEdit
    const handleEdit = (itemData: any) => {

        setAddItem({
            id: itemData.id
        })
        setRateCardRules(itemData)
        setTaxonomy(itemData?.TaxonomyDetails)

    }

    const handleSaveItem = async (data: any) => {

    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(rateCardRules));
        const [localTaxonomyItems, setLocalTaxonomyItems] = useState(deepCopy(taxonomy));

        const handleLocalFormChange = (value: any, field: any) => {
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleTaxonomyFormChange = (index: number, key: keyof TaxonomyDetails, value: any) => {
            setLocalTaxonomyItems((prev) =>
                prev.map((v, i) => (i === index ? { ...v, [key]: value } : v))
            );
        };

        const handleItemSubmit = async () => {
            const data: any = {
                Id: localItems?.Id ? localItems?.Id : 0,
                Name: localItems?.Name,
                EdgeDBNDomainCode: localItems?.EdgeDBNDomainCode,
                RateCardType: localItems?.RateCardType,
                IsActive: localItems?.IsActive,
                StartDateUtc: localItems?.StartDateUtc,
                EndDateUtc: localItems?.EndDateUtc,
                MinimunDistance: localItems?.MinimunDistance,
                MaximumDistance: localItems?.MaximumDistance,
                IsInlcudeStoreAsOriginLocation: localItems?.IsInlcudeStoreAsOriginLocation,
                DistanceUnitId: localItems?.DistanceUnitId,
                DistanceIncrement: localItems?.DistanceIncrement,
                DistanceIncrementCharge: localItems?.DistanceIncrementCharge,
                PinCode: localItems?.PinCode,
                TaxonomyDetails: localTaxonomyItems

            }
            await setRateCardFullRulesData((prevState: any) => {
                // Check if the item exists by Name
                const exists = prevState.some((item: any) => item.Name == data.Name);
                // If it exists, update it, otherwise add the new item
                return exists
                    ? prevState.map((item: any) => item.Name == data.Name ? data : item)
                    : [...prevState, data];
            });

            await closeModal()
        }

        const addTaxonomyRow = () => {
            setLocalTaxonomyItems((prev) => [
                ...prev,
                {
                    ProductId: '',
                    ProductName: '',
                    ProductTypeName: '',
                    DistanceUnitId: '',
                    VariantName: '',
                    Charge: 0,
                    IsIncludeProductBasePrice: '',
                    DistanceIncrement: '',
                    DistanceIncrementCharge: '',
                    MinimunDistance: '',
                    MaximumDistance: '',
                }
            ]);
        };
        const removeTaxonomy = (index: number) => {
            setLocalTaxonomyItems((prev) => prev.filter((_, i) => i !== index));
        };
        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalRateCardRuleComponent
                        Close={closeModal}
                        onInnerBasicFormChange={handleLocalFormChange}
                        pinCodes={pinCodesLists?.result?.items}
                        categories={categoryLists?.result?.items}
                        distances={measureDimensionsLists?.result?.items}
                        handleItemSubmit={handleItemSubmit}
                        selectMobility={localItems}
                        taxonomy={localTaxonomyItems}
                        handleTaxonomyFormChange={handleTaxonomyFormChange}
                        removeTaxonomy={removeTaxonomy}
                        addTaxonomyRow={addTaxonomyRow}
                        variants={variantsLists?.result?.items}
                        productTypes={productTypesLists?.result?.items}
                        products={productsLists?.result?.items}

                    />

                </Popup>
            </>
        )
    }

    //Api Load
    const commonApiLoad = async () => {
        await dispatch(customers.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/customers/list`, entity: 'customers', jsonData: {} }))
        await dispatch(pinCodes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/pin-codes/list`, entity: 'pincodes', jsonData: {} }))
        await dispatch(categories.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`, entity: 'categories', jsonData: {} }))
        await dispatch(measureDimensions.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/list`, entity: 'measureDimensions', jsonData: {} }))
        await dispatch(variants.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/variants/list`, entity: 'variants', jsonData: {} }))
        await dispatch(productTypes.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`, entity: 'productTypes', jsonData: {} }))
        await dispatch(products.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`, entity: 'products', jsonData: {} }))
    }

    //useEffect
    useEffect(() => {
        setAssociatedAccountTypeId(selectedRateCards?.AssociatedAccountTypeId);
        setOwnerId(selectedRateCards?.OwnerId);
    }, [selectedRateCards]);


    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text == accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);

    useEffect(() => {
        switch (ownerId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerId]);

    useEffect(() => {
        switch (ownerId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);

    //common useEffect
    useEffect(() => {
        createColumnDefs()
        commonApiLoad()
        if (parmas?.id > 0) {
            fetchQueryById()

        } else {

            setIsLoading(false)
        }
    }, []);

    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedRateCards(querydata)

                const mobilityItemsData: any = querydata?.RateCards.map((item: any) => {

                    const itemData = {

                        Id: item?.Id,
                        Name: item?.BasicDetail?.Name,
                        EdgeDBNDomainCode: item?.BasicDetail?.EdgeDBNDomainCode,
                        RateCardType: item?.BasicDetail?.RateCardType,
                        IsActive: item?.BasicDetail?.IsActive,
                        StartDateUtc: item?.BasicDetail?.StartDateUtc,
                        EndDateUtc: item?.BasicDetail?.EndDateUtc,
                        MinimunDistance: item?.Shipping?.MinimunDistance,
                        MaximumDistance: item?.Shipping?.MaximumDistance,
                        IsInlcudeStoreAsOriginLocation: item?.Shipping?.IsInlcudeStoreAsOriginLocation,
                        DistanceUnitId: item?.Shipping?.DistanceUnitId,
                        DistanceIncrement: item?.Shipping?.DistanceIncrement,
                        DistanceIncrementCharge: item?.Shipping?.DistanceIncrementCharge,
                        PinCode: item?.PINCode?.PinCode,
                        TaxonomyDetails: item?.Shipping?.TaxonomyDetails
                    }
                    return itemData
                })
                setRateCardFullRulesData(mobilityItemsData)

            }
        },
        [isQuery]
    )

    // Submit the RateCard Function
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )
        const mobilityItemsData: any = rateCardFullRulesData.map((item: any) => {

            const itemData = {
                "Id": item?.Id,
                "BasicDetail": {
                    "Name": item?.Name,
                    "EdgeDBNDomainCode": item?.EdgeDBNDomainCode,
                    "RateCardType": item?.RateCardType,
                    "IsActive": item?.IsActive,
                    "EntityTypeId": 0,
                    "EntityId": 0,
                    "StartDateUtc": item?.StartDateUtc,
                    "EndDateUtc": item?.EndDateUtc
                },
                "PINCode": {
                    "PinCode": item?.PinCode
                },
                "Shipping": {
                    "MinimunDistance": Number(item?.MinimunDistance),
                    "MaximumDistance": Number(item?.MaximumDistance),
                    "IsInlcudeStoreAsOriginLocation": item?.IsInlcudeStoreAsOriginLocation,
                    "DistanceUnitId": item?.DistanceUnitId,
                    "DistanceIncrement": Number(item?.DistanceIncrement),
                    "DistanceIncrementCharge": Number(item?.DistanceIncrementCharge),
                    "TaxonomyDetails": item?.TaxonomyDetails
                }
            }
            return itemData
        })
        const rateData = {
            "Id": selectedRateCards?.RateCardPolicyId || 0,
            "Name": selectedRateCards?.Name,
            "IsActive": selectedRateCards?.IsActive,
            "OwnerId": selectedRateCards?.OwnerId,
            "AssociatedAccountId": selectedRateCards?.AssociatedAccountId,
            "AssociatedAccountTypeId": selectedRateCards?.AssociatedAccountTypeId,
            "Description": selectedRateCards?.Description,
            "StartDateUtc": selectedRateCards?.StartDateUtc,
            "EndDateUtc": selectedRateCards?.EndDateUtc,
            "DisplayOrder": Number(selectedRateCards?.DisplayOrder),
            "Inclusions": selectedRateCards?.Inclusions,
            "Exclusions": selectedRateCards?.Exclusions,
            "RateCards": mobilityItemsData,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []
            }
        }

        if (parmas?.id > 0) {
            await dispatch(rateCards.resetAction({ actionType: 'update' }))
            await dispatch(rateCards.update({
                url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/mobility/rate-cards`, entity: 'rateCards', jsonData: {
                    Context: {},
                    Records: [
                        rateData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(rateCards.resetAction({ actionType: 'create' }))
            await dispatch(rateCards.create({
                url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/mobility/rate-cards`, entity: 'rateCards', jsonData: {

                    Context: {},
                    Records: [
                        rateData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }

    return (
        <>
            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :
                <RateCardComponent
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                    rateCardRules={rateCardRules}
                    rateCardFullRulesData={rateCardFullRulesData}
                    back={back}
                    onFormMediaItemChange={handleFormMediaItemChange}
                    onInnerFormChange={handleInnerFormChange}
                    customers={customerLists?.result?.items}
                    // allTags
                    selectedRateCards={selectedRateCards}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    policyOwnerTypesListLoading={libraryData?.isLoading}
                    policyOwnerTypes={libraryData?.result?.PolicyOwnerType}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    id={parmas?.id}
                    handleFormSubmit={handleFormSubmit}
                />
            }

        </>
    )

}

export default ManagementRateCardAdvance;